import type { TemplateProps } from '../types';
import { DefaultPanel } from '../../components/DefaultPanel';

export function Panel(props: TemplateProps): preact.JSX.Element {
  return <DefaultPanel {...props} className="yd-bar-panel" />;
}
